<template>
  <el-drawer title="企业微信聊天记录" :visible.sync="drawer" size="50%" :before-close="handleClose">
    <div class="m-tabs-content">
      <wx-work-chat :chatId="chatId" :chatName="chatName" />
    </div>
  </el-drawer>
</template>

<script>
import WxWorkChat from 'common/WxWorkChat'
export default {
  name: 'RisksDrawer',
  components: { WxWorkChat },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    chatId: {
      type: String,
      default: ''
    },
    chatName: {
      type: String,
      default: ''
    },
  },
  computed: {
  },
  watch: {
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    handleClose () {
      this.$emit('handleClose', false)
    }
  }
}
</script>
<style lang="stylus" scoped>
.el-drawer__wrapper >>> .el-drawer__body {
  overflow-y: auto
}
* >>> .el-drawer__header {
  color: #409eff;
  font-size: medium;
}
.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}
.risks {
  border: 1px solid #D8DDE5;
}
.risks-span {
  line-height: .4rem;
  padding: 10px 12px 10px;
}
.bg {
  background: #f3f7ff;
}
.m-tabs-content >>> .el-card__body {
  padding: 0;
}
.box-card {
  margin-bottom: .2rem;
  border-top: 1px solid #86B9D6;
}
.tr {
  text-align: right;
}
.span-flex {
  display: flex;
  align-items: center;
  justify-content: right;
  color: rgb(13, 88, 165);
}
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/CompanyWxWorkChatDrawer.vue